"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModeTabsNav = exports.Mode = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../utils");
var _ui = require("../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "currentColor"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var transfer = function transfer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.24 6.02557L0.25 10.0256L4.24 14.0256V11.0256H11.25V9.02557H4.24V6.02557ZM18.25 4.02557L14.26 0.0255737V3.02557H7.25V5.02557H14.26V8.02557L18.25 4.02557Z",
    fill: "currentColor"
  }));
};
transfer.defaultProps = {
  width: "19",
  height: "15",
  viewBox: "0 0 19 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Mode = {
  SEND: 'SEND',
  CONVERT: 'CONVERT'
};
exports.Mode = Mode;
var TransferIcon = (0, _styledComponents.default)(function () {
  return /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    width: 12,
    as: transfer
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: -3px;\n"])));
var ModeTabsNav = function ModeTabsNav(_ref) {
  var activeTab = _ref.activeTab,
    onTabChange = _ref.onTabChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var isSm = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.sm
  });
  return /*#__PURE__*/_react.default.createElement(_ui.TabsNav, {
    column: isSm
  }, /*#__PURE__*/_react.default.createElement(_ui.TabsNavItem, null, /*#__PURE__*/_react.default.createElement(_ui.TabsNavLink, {
    onClick: function onClick() {
      return onTabChange(Mode.SEND);
    },
    active: activeTab === Mode.SEND
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    width: 10,
    as: arrowRotate,
    rotate: 180
  }), t('send')))), /*#__PURE__*/_react.default.createElement(_ui.TabsNavItem, null, /*#__PURE__*/_react.default.createElement(_ui.TabsNavLink, {
    onClick: function onClick() {
      return onTabChange(Mode.CONVERT);
    },
    active: activeTab === Mode.CONVERT
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TransferIcon, null), t('sendConvert')))));
};
exports.ModeTabsNav = ModeTabsNav;